import SupplierEventProduct, { INCOTerms } from "@/features/SupplierEvents/SupplierEventProduct";

export default class SupplierEventProductRequestModel {
    id: string | null = "";
    supplierEventID: string | null = null;
    productID: string | null = null;
    currentPriceUSD: number | null = null;
    newProposedPriceUSD: number | null = null;
    newFinalPriceUSD: number | null = null;
    currentINCOTerms: INCOTerms | null = null;
    currentINCOTermsCountryID: string | null = null;
    currentINCOTermsCity: string | null = "";
    newProposedINCOTerms: INCOTerms | null = null;
    newProposedINCOTermsCountryID: string | null = null;
    newProposedINCOTermsCity: string | null = "";
    newFinalINCOTerms: INCOTerms | null = null;
    newFinalINCOTermsCountryID: string | null = null;
    newFinalINCOTermsCity: string | null = "";
    proposedPercentChange: number | null = null;
    finalPercentChange: number | null = null;
    startDate: Date | null = null;
    wasNegotiated: boolean | null = null;
    isConsignment: boolean = false;

    constructor(product: SupplierEventProduct) {
        this.id = product.id.length ? product.id : null;
        this.supplierEventID = product.supplierEventID;
        this.productID = product.productID;
        this.currentPriceUSD = product.currentPriceUSD;
        this.newProposedPriceUSD = product.newProposedPriceUSD;
        this.newFinalPriceUSD = product.newFinalPriceUSD;
        this.currentINCOTerms = product.currentINCOTerms;
        this.currentINCOTermsCountryID = product.currentINCOTermsCountryID;
        this.currentINCOTermsCity = product.currentINCOTermsCity === null ? "" : product.currentINCOTermsCity;
        this.newProposedINCOTerms = product.newProposedINCOTerms;
        this.newProposedINCOTermsCountryID = product.newProposedINCOTermsCountryID;
        this.newProposedINCOTermsCity = product.newProposedINCOTermsCity === null ? "" : product.newProposedINCOTermsCity;
        this.newFinalINCOTerms = product.newFinalINCOTerms;
        this.newFinalINCOTermsCountryID = product.newFinalINCOTermsCountryID;
        this.newFinalINCOTermsCity = product.newFinalINCOTermsCity === null ? "" : product.newFinalINCOTermsCity;
        this.proposedPercentChange = product.proposedPercentChange;
        this.finalPercentChange = product.finalPercentChange;
        this.startDate = product.startDate ? new Date(product.startDate) : null;
        this.wasNegotiated = product.wasNegotiated;
        this.isConsignment = product.isConsignment;
    }
}
